module.exports = __webpack_public_path__ + "static/media/Whismur_gaussian2.c9fdf413.png";